import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { loadEmployeeComments } from '../../comments/actions/load-comments';
import { commentsForIdSelector } from '../../comments/comment-selectors';

import { UiButton } from '../../ui/ui-button';

const mapStateToProps = (state: any, { employeeId }: InputProps) => ({
  notesCount: commentsForIdSelector(state, employeeId, 'employee')?.length,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { employeeId }: InputProps,
) => ({
  actions: {
    loadComments: () => dispatch(loadEmployeeComments({ employeeId })),
  },
});

type InputProps = {
  className?: string;
  employeeId: number;
  onClick: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  showCount?: boolean;
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & StateProps & DispatchProps;

export const EmployeeNotesButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ className, onClick, showCount, notesCount, actions }: Props) => {
  useEffect(() => {
    if (showCount) {
      actions.loadComments();
    }
  });

  const truncatedNotesCount = notesCount && notesCount >= 10 ? '(10+)' : `(${notesCount})`;

  return (
    <UiButton onClick={onClick} variant="tertiary" className={className}>
      Notes {showCount && notesCount ? truncatedNotesCount : ''}
    </UiButton>
  );
});
